/* eslint-disable react-hooks/exhaustive-deps */
import { Button, Input, Pagination, Select, SelectItem, Spinner, Table, TableBody, TableCell, TableColumn, TableHeader, TableRow, User } from '@nextui-org/react';
import { IconArrowLeft, IconMoodCheck, IconMoodAngry } from '@tabler/icons-react';
import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { classNames, Constants, fromPhotos } from '../../../../utils';
import { TeacherStudentSerivce, TeacherConductService, TeacherAttendeceService } from '../../../../services';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import moment from 'moment';


const MOOD_TYPE = {
  BAD: 0,
  GOOD: 1,
}

const getIcon = (mood) => {
  switch (mood) {
    case MOOD_TYPE.GOOD:
      return { icon: <IconMoodCheck />, color: 'bg-green', textColor: 'text-green' };
    case MOOD_TYPE.BAD:
      return { icon: <IconMoodAngry />, color: 'bg-danger', textColor: 'text-danger' };
    default:
      return { icon: <IconMoodCheck />, color: 'text-green' };
  }
}

const ConductsView = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { filterBy, grades, isLoading, sections, lapses, students, pagination, goToPage, canResetFilter, reload } = useFetchTable(location.state);

  return (
    <div className='flex flex-col'>
      {isLoading && (
        <div className="w-screen h-screen fixed inset-0 z-[70] flex justify-center items-center bg-white/30">
          <Spinner />
        </div>
      )}


      <div className="flex gap-4">
        <IconArrowLeft className="cursor-pointer" onClick={() => navigate('/conduct', { replace: true })} />
        <span className="font-bold text-secondary capitalize">{location?.state?.name} - {location?.state?.school_grade?.name}</span>
      </div>

      <main className='mt-5'>
        <Filters
          filterBy={filterBy}
          grades={grades}
          sections={sections}
          lapses={lapses}
          canResetFilter={canResetFilter}
          resetFilter={() => reload()}
        />


        <div className='mt-5'>
          <Table
            aria-label="Conducta"
            className='mt-5'
            color="primary"
          >
            <TableHeader>
              <TableColumn>Estudiantes</TableColumn>
              <TableColumn>Grado</TableColumn>
              <TableColumn>Sección</TableColumn>
              <TableColumn>Descripción</TableColumn>
              <TableColumn width={150}>Fecha</TableColumn>
              <TableColumn>Conducta</TableColumn>
            </TableHeader>
            <TableBody items={students} emptyContent="Utilice los filtros para ver las conductas registradas">
              {(item) => {
                const student = item?.student
                const section = !!student?.sectionAssignments.length ? student.sectionAssignments[0].section : null;
                return (
                  <TableRow key={student?.id}>
                    <TableCell>
                      <User
                        key={student?.photo}
                        avatarProps={{ showFallback: true, radius: 'full', src: student?.photo ? fromPhotos(student.photo) : null }}
                        name={student?.fullname}
                        classNames={{ description: 'text-foreground-500', name: 'capitalize' }}
                      />
                    </TableCell>
                    <TableCell className='capitalize'>{student?.school_grade?.name}</TableCell>
                    <TableCell className='capitalize'>{section?.name}</TableCell>
                    <TableCell>{item?.description}</TableCell>
                    <TableCell>{moment(item?.created_at).format('DD-MM-YYYY')}</TableCell>
                    <TableCell>
                      <div className='flex justify-between gap-2 items-center'>
                        <span
                          className={`font-bold ${getIcon(item?.type).textColor}`}
                        >
                          {item?.type_text}
                        </span>
                        <IconMood
                          mood={item?.type}
                          isActive={true}
                        />
                      </div>
                    </TableCell>
                  </TableRow>
                )
              }}
            </TableBody>
          </Table>



        </div>



        <div className="flex w-full justify-center mt-4">
          <Pagination
            showControls
            variant="bordered"
            page={pagination.page}
            total={pagination.pages}
            onChange={goToPage}
          />
        </div>

      </main>
    </div>
  )
}


const IconMood = ({ mood, onClick, isActive }) => {

  const { icon, color } = getIcon(mood);

  return (
    <div
      className={classNames(
        'text-white p-1 rounded-lg h-8 w-8 flex justify-center items-center cursor-pointer',
        isActive ? color : 'bg-foreground-300'
      )}
      onClick={onClick}
    >
      {icon}
    </div>
  );
}




const Filters = ({ filterBy, grades, sections, lapses, canResetFilter, resetFilter }) => {
  const initialFilter = {
    school_grade_id: '',
    school_section_id: '',
    school_lapse_id: '',
    created_at: '',
  };
  const [form, setForm] = useState(initialFilter);

  const onChange = (value, target) => {
    setForm(s => ({ ...s, [target]: value }));
    filterBy(value, target);
  }


  return (
    <section className='flex flex-col  items-end gap-4 md:w-[70%] md:flex-row'>
      <Select
        label="Sección"
        labelPlacement="outside"
        placeholder=" "
        variant="bordered"
        radius="sm"
        classNames={{
          label: 'font-semibold',
          base: 'w-full',
          trigger: 'border-1',
        }}
        disallowEmptySelection={true}
        selectedKeys={!!form.school_section_id ? [form.school_section_id] : []}
        onSelectionChange={v => onChange(v.currentKey, 'school_section_id')}
      >
        {sections.map((item) => (
          <SelectItem key={item.value} value={item.value}>{item.label}</SelectItem>
        ))}
      </Select>

      <Select
        label="Lapso"
        labelPlacement="outside"
        placeholder=" "
        variant="bordered"
        radius="sm"
        classNames={{
          label: 'font-semibold',
          base: 'w-full',
          trigger: 'border-1',
        }}
        disallowEmptySelection={true}
        selectedKeys={!!form.school_lapse_id ? [form.school_lapse_id] : []}
        onSelectionChange={v => onChange(v.currentKey, 'school_lapse_id')}
      >
        {lapses.map((item) => (
          <SelectItem key={item.value} value={item.value}>{item.label}</SelectItem>
        ))}
      </Select>

      <Input
        label="Fecha"
        labelPlacement="outside"
        placeholder=" "
        type="date"
        radius="sm"
        variant="bordered"
        value={form.created_at}
        onValueChange={v => onChange(v, 'created_at')}
      />

      {canResetFilter && (
        <Button
          variant="light"
          className="text-primaryDark w-full"
          onClick={() => {
            setForm(initialFilter);
            resetFilter();
          }}
        >
          Limpiar filtros
        </Button>
      )}
    </section>
  )
}

const useFetchTable = (subject) => {

  const initialFilters = {
    page: 1,
    perPage: Constants.PER_PAGE,
    subject_id: subject?.id,
    school_grade_id: subject?.school_grade_id,
    school_year_id: subject?.school_grade?.school_year_id,
    school_section_id: '',
    school_lapse_id: '',
    created_at: '',
  };


  const initialPagination = {
    page: 1,
    pages: 1,
    total: 0,
    perPage: Constants.PER_PAGE,
  };


  const user = useSelector(state => state.user);
  const [data, setData] = useState([]);
  const [canFetch, setCanFetch] = useState(true);
  const [filters, setFilters] = useState(initialFilters);
  const [pagination, setPagination] = useState(initialPagination);
  const [lapses, setLapses] = useState([]);
  const [sections, setSections] = useState([]);
  const [students, setStudents] = useState([])


  const toSelect = (items) => items.map(x => ({ ...x, value: String(x.id), label: x.name }));

  const fetchData = async () => {
    if (!canFetch || !filters.school_grade_id || !filters.school_section_id || !filters.school_lapse_id || !filters.created_at) return;
    setCanFetch(false);

    try {
      const students = await TeacherConductService.conduct.getConducts({
        ...filters,
        professor_id: user.id,
      });

      const { data, ...rest } = students;


      setStudents(data);
      setPagination(rest);
      setCanFetch(true);

    } catch (error) {
      onError(String(error));
      setCanFetch(true);
    }
  }

  const fetchSelects = async () => {
    try {
      const selects = await TeacherAttendeceService.attendence.getSelects({ professor_id: user.id });
      setLapses(toSelect(selects.lapses));
      setSections(toSelect(selects.sections));
      setCanFetch(true)

    } catch (error) {
      setData([]);
      onError(String(error));
    }
  }

  const getCurrentPagination = () => {
    let pag;
    setPagination(s => {
      pag = s;
      return s;
    });
    return pag;
  }

  const changePerPage = (perPage) => {
    setCanFetch(true);
    setFilters({ ...filters, perPage });
  }

  const goToPage = (page) => {
    const pagination = getCurrentPagination();
    if (page >= 1 && page <= pagination.pages && page !== pagination.page) {
      setCanFetch(true);
      setFilters({ ...filters, page });
    }
  }


  const onError = (msg) => toast.error(msg);

  const filterBy = (value, target) => {
    setFilters({ ...filters, page: 1, [target]: value })
  }

  const reload = (inSamePage = false) => {
    setCanFetch(true);
    setFilters(initialFilters);
    setPagination(initialPagination)
    setStudents([]);
  }

  const canResetFilter = () => {
    const { page, perPage, ...initial } = initialFilters;
    const { page: _, perPage: __, ...current } = filters;
    const initFilter = JSON.stringify(initial);
    const currFilter = JSON.stringify(current);
    return initFilter !== currFilter;
  }



  useEffect(() => {
    fetchData();
  }, [filters]);


  useEffect(() => {
    fetchSelects();
  }, [])



  return {
    canResetFilter: canResetFilter(),
    goToPage,
    changePerPage,
    pagination,
    data,
    filterBy,
    filters,
    isLoading: !canFetch,
    students,
    reload,
    lapses: lapses.filter(x => x.school_year_id === +filters.school_year_id),
    sections: sections.filter(x => x.school_grade_id === +filters.school_grade_id),
  }
}

export default ConductsView;